import { RSAEncrypt } from '@/utils/auth/RSAEncrypt'

const encrypt = new RSAEncrypt({ key: import.meta.env.VITE_RSA_PUBLIC_KEY, shaType: 'sha256' })

const createPasswordObject = (password: string) => {
  return JSON.stringify({
    password: password,
    timestamp: new Date().toISOString()
  })
}

const authEncryptPassword = (password: string) => {
  const passwordObject = createPasswordObject(password)
  const encryptedPassword = encrypt.encrypt(passwordObject)
  return encryptedPassword
}

export { authEncryptPassword }
